<template>
    <span>
        <div
            :key="index"
            class="card"
            v-for="(item, index) in list"
            v-if="is_item_active(item)"
        >
            <div class="card-content">
                <div class="content">
                    <slot :index="index" :item="item"></slot>
                </div>
            </div>
            <div class="card-footer" v-if="!disableActions && !is_locked">
                <slot :index="index" :item="item" name="item_actions"></slot>

                <span class="float-right">
                    <o-list-add
                        :default-value="defaultNewValue"
                        :item-name="itemName"
                        :list="list"
                        @change="onChanged"
                        type="primary"
                        v-if="!is_locked && index === list.length - 1"
                    ></o-list-add>
                    <o-list-actions
                        :display-order="displayOrder"
                        :index="index"
                        :list="list"
                        @change="onChanged"
                    />
                </span>
            </div>
        </div>
        <div
            class="card-footer has-background-grey-lighter d-flex flex-row-reverse border"
            v-if="!is_locked && (list || []).length === 0"
        >
            <o-list-add
                :default-value="defaultNewValue"
                :item-name="itemName"
                :list="list"
                @change="onChanged"
                type="primary"
                v-if="!is_locked"
            >
            </o-list-add>
        </div>
    </span>
</template>

<script>
import OListActions from "./OListActions.vue";
import OListAdd from "./OListAdd.vue";
import { filter_active_list, is_item_active } from "../../utils/active";
import moment from "moment";

export default {
    name: "ORepeatingCards",
    components: {
        OListActions: OListActions,
        OListAdd: OListAdd,
    },
    props: {
        list: { type: Array, default: () => [] },
        disableMove: { type: Boolean, default: false },
        disableAdd: { type: Boolean, default: false },
        disableDelete: { type: Boolean, default: false },
        disableActions: { type: Boolean, default: false },
        displayOrder: { type: String, default: null },
        defaultNewValue: {
            type: Object,
            default: () => {},
        },
        itemName: { type: String, default: "Item" },

        formState: {
            type: Object,
            default: () => {},
        },
    },
    model: {
        prop: "list",
        event: "change",
    },
    methods: {
        onChanged() {
            this.$emit("change", this.list);
        },
        is_item_active(item) {
            var now = moment();

            return is_item_active(item, now);
        },
    },
    computed: {
        filtered_list() {
            var result = this.list;

            result = filter_active_list(result); // Filter for Active only

            return result;
        },
        is_locked() {
            if (this.formState) {
                if ("locked" in this.formState) {
                    return this.formState.locked;
                }
            }

            return false;
        },
    },
    data: () => ({}),
};
</script>

<style scoped></style>
